import React from "react";
import { Button } from "reactstrap";
import type { WorkOrderTask } from "features/WorkOrders/types/work-order.types";
import "quill/dist/quill.snow.css";

type Props = {
  task: WorkOrderTask;
  index: number;
  canMutate: boolean;
  busy: boolean;
  onEdit: (task: WorkOrderTask) => void;
  onToggleCompleted: (task: WorkOrderTask) => Promise<void>;
  onDelete: (task: WorkOrderTask) => Promise<void>;
};

export default function WorkOrderTaskItem({
  task,
  index,
  canMutate,
  busy,
  onEdit,
  onToggleCompleted,
  onDelete,
}: Props) {
  return (
    <div className="border rounded p-3">
      <div className="d-flex align-items-start justify-content-between gap-2">
        <div>
          <p className="text-muted small mb-1">Task #{index + 1}</p>
          <h6 className="mb-1">{task.title?.trim() || `Task ${index + 1}`}</h6>
        </div>
        <span
          className={`badge ${
            task.isCompleted
              ? "bg-success-subtle text-success"
              : "bg-warning-subtle text-warning"
          }`}
        >
          {task.isCompleted ? "Completed" : "Pending"}
        </span>
      </div>

      {task.description?.trim() ? (
        <div className="text-muted mb-0 ql-snow">
          <div
            className="ql-editor p-0"
            // Rich text from task modal (Quill / ValueEditor)
            dangerouslySetInnerHTML={{ __html: task.description }}
          />
        </div>
      ) : null}

      <div className="hstack gap-2 mt-3">
        <Button
          size="sm"
          color="soft-primary"
          disabled={!canMutate || busy || task.id == null}
          onClick={() => void onToggleCompleted(task)}
        >
          {task.isCompleted ? "Mark pending" : "Mark completed"}
        </Button>
        <Button
          size="sm"
          color="soft-secondary"
          disabled={!canMutate || busy || task.id == null}
          onClick={() => onEdit(task)}
        >
          <i className="ri-pencil-line align-bottom me-1" />
          Edit
        </Button>
        <Button
          size="sm"
          color="soft-danger"
          disabled={!canMutate || busy || task.id == null}
          onClick={() => void onDelete(task)}
        >
          <i className="ri-delete-bin-line align-bottom me-1" />
          Delete
        </Button>
      </div>
    </div>
  );
}
